var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15, _g16, _g17, _g18, _path, _path2, _path3, _path4, _path5, _g19, _g20, _g21, _g22, _g23, _g24, _g25, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMatrix2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 3,
    height: 165,
    viewBox: "0 0 3 165",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.3
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9306 0.61L2.53061 0H0.140625L0.740631 0.61H1.9306Z",
    fill: "url(#paint0_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 1.9299L2.3703 2.2299L2.67032 1.9299V0.149902L2.07031 0.749902V1.9299Z",
    fill: "url(#paint1_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 2.82002V4.01002L2.67032 4.61002V2.82002L2.3703 2.52002L2.07031 2.82002Z",
    fill: "url(#paint2_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740631 4.1499L0.140625 4.7499H2.53061L1.9306 4.1499H0.740631Z",
    fill: "url(#paint3_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 2.08008L0.44043 2.38008L0.740448 2.68008H1.93042L2.23044 2.38008L1.93042 2.08008H0.740448Z",
    fill: "url(#paint4_linear_2371_121358)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.49
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 22.55L2.52963 21.95H0.139648L0.739655 22.55H1.92963Z",
    fill: "url(#paint5_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 23.8798L2.3703 24.1798L2.67032 23.8798V22.0898L2.07031 22.6998V23.8798Z",
    fill: "url(#paint6_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 26.0999L0.139648 26.6999H2.52963L1.92963 26.0999H0.739655Z",
    fill: "url(#paint7_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 24.77L0.300018 24.47L0 24.77V26.56L0.600006 25.95V24.77Z",
    fill: "url(#paint8_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 24.02L0.44043 24.33L0.740448 24.63H1.93042L2.23044 24.33L1.93042 24.02H0.740448Z",
    fill: "url(#paint9_linear_2371_121358)"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.96
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 17.07L2.52963 16.47H0.139648L0.739655 17.07H1.92963Z",
    fill: "url(#paint10_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 19.28V20.47L2.67032 21.07V19.28L2.3703 18.98L2.07031 19.28Z",
    fill: "url(#paint11_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 20.6099L0.139648 21.2099H2.52963L1.92963 20.6099H0.739655Z",
    fill: "url(#paint12_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 19.28L0.300018 18.98L0 19.28V21.07L0.600006 20.47V19.28Z",
    fill: "url(#paint13_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 18.54L0.44043 18.84L0.740448 19.14H1.93042L2.23044 18.84L1.93042 18.54H0.740448Z",
    fill: "url(#paint14_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 17.2099L0 16.6099V18.3999L0.300018 18.6999L0.600006 18.3999V18.0999V17.2099Z",
    fill: "url(#paint15_linear_2371_121358)"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 11.58L2.52963 10.98H0.139648L0.739655 11.58H1.92963Z",
    fill: "url(#paint16_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 13.79V14.98L2.67032 15.58V13.79L2.3703 13.49L2.07031 13.79Z",
    fill: "url(#paint17_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 15.1199L0.139648 15.7199H2.52963L1.92963 15.1199H0.739655Z",
    fill: "url(#paint18_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 13.79L0.300018 13.49L0 13.79V15.58L0.600006 14.98V13.79Z",
    fill: "url(#paint19_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 13.05L0.44043 13.35L0.740448 13.65H1.93042L2.23044 13.35L1.93042 13.05H0.740448Z",
    fill: "url(#paint20_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 11.1199V12.6099V12.9099L0.300018 13.2099L0.600006 12.9099V12.6099V11.7199L0 11.1199Z",
    fill: "url(#paint21_linear_2371_121358)"
  }))), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.32
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 39.0202L2.52963 38.4102H0.139648L0.739655 39.0202H1.92963Z",
    fill: "url(#paint22_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 41.2302V42.4202L2.67032 43.0202V41.2302L2.3703 40.9302L2.07031 41.2302Z",
    fill: "url(#paint23_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 42.5601L0.139648 43.1601H2.52963L1.92963 42.5601H0.739655Z",
    fill: "url(#paint24_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 41.2302L0.300018 40.9302L0 41.2302V43.0202L0.600006 42.4202V41.2302Z",
    fill: "url(#paint25_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 40.4902L0.44043 40.7902L0.740448 41.0902H1.93042L2.23044 40.7902L1.93042 40.4902H0.740448Z",
    fill: "url(#paint26_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 39.1601L0 38.5601V40.3401L0.300018 40.6501L0.600006 40.3401V40.0501V39.1601Z",
    fill: "url(#paint27_linear_2371_121358)"
  }))), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.33
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 33.5299L2.52963 32.9299H0.139648L0.739655 33.5299H1.92963Z",
    fill: "url(#paint28_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 34.8598L2.3703 35.1598L2.67032 34.8598V33.0698L2.07031 33.6698V34.8598Z",
    fill: "url(#paint29_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 37.0698L0.139648 37.6698H2.52963L1.92963 37.0698H0.739655Z",
    fill: "url(#paint30_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 35.7399L0.300018 35.4399L0 35.7399V37.5299L0.600006 36.9299V35.7399Z",
    fill: "url(#paint31_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 35L0.44043 35.3L0.740448 35.6H1.93042L2.23044 35.3L1.93042 35H0.740448Z",
    fill: "url(#paint32_linear_2371_121358)"
  }))), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.48
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 29.3701L2.3703 29.6701L2.67032 29.3701V27.5801L2.07031 28.1801V29.3701Z",
    fill: "url(#paint33_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 30.2502V31.4402L2.67032 32.0402V30.2502L2.3703 29.9502L2.07031 30.2502Z",
    fill: "url(#paint34_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 29.51L0.44043 29.81L0.740448 30.11H1.93042L2.23044 29.81L1.93042 29.51H0.740448Z",
    fill: "url(#paint35_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 27.5801V29.0801V29.3701L0.300018 29.6701L0.600006 29.3701V29.0801V28.1801L0 27.5801Z",
    fill: "url(#paint36_linear_2371_121358)"
  }))), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 56.81L2.3703 57.11L2.67032 56.81V55.02L2.07031 55.62V56.81Z",
    fill: "url(#paint37_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 57.6901V58.8801L2.67032 59.4801V57.6901L2.3703 57.3901L2.07031 57.6901Z",
    fill: "url(#paint38_linear_2371_121358)"
  }))), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.62
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 49.9901L2.52963 49.3901H0.139648L0.739655 49.9901H1.92963Z",
    fill: "url(#paint39_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 52.2001V53.3901L2.67032 53.9901V52.2001L2.3703 51.9001L2.07031 52.2001Z",
    fill: "url(#paint40_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 53.53L0.139648 54.13H2.52963L1.92963 53.53H0.739655Z",
    fill: "url(#paint41_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 51.4602L0.44043 51.7602L0.740448 52.0602H1.93042L2.23044 51.7602L1.93042 51.4602H0.740448Z",
    fill: "url(#paint42_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 50.13L0 49.53V51.32L0.300018 51.62L0.600006 51.32V51.02V50.13Z",
    fill: "url(#paint43_linear_2371_121358)"
  }))), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.97
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 45.83L2.3703 46.13L2.67032 45.83V44.04L2.07031 44.65V45.83Z",
    fill: "url(#paint44_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 46.7199V47.8999L2.67032 48.4999V46.7199L2.3703 46.4199L2.07031 46.7199Z",
    fill: "url(#paint45_linear_2371_121358)"
  }))), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.79
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 71.9401L2.52963 71.3401H0.139648L0.739655 71.9401H1.92963Z",
    fill: "url(#paint46_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 73.27L2.3703 73.57L2.67032 73.27V71.48L2.07031 72.08V73.27Z",
    fill: "url(#paint47_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 75.48L0.139648 76.08H2.52963L1.92963 75.48H0.739655Z",
    fill: "url(#paint48_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 74.1501L0.300018 73.8501L0 74.1501V75.9401L0.600006 75.3401V74.1501Z",
    fill: "url(#paint49_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 73.4102L0.44043 73.7102L0.740448 74.0102H1.93042L2.23044 73.7102L1.93042 73.4102H0.740448Z",
    fill: "url(#paint50_linear_2371_121358)"
  }))), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.86
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 66.4501L2.52963 65.8501H0.139648L0.739655 66.4501H1.92963Z",
    fill: "url(#paint51_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 67.78L2.3703 68.08L2.67032 67.78V65.99L2.07031 66.59V67.78Z",
    fill: "url(#paint52_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 68.6701V69.8501L2.67032 70.4501V68.6701L2.3703 68.3601L2.07031 68.6701Z",
    fill: "url(#paint53_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 69.99L0.139648 70.6H2.52963L1.92963 69.99H0.739655Z",
    fill: "url(#paint54_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 68.6701L0.300018 68.3601L0 68.6701V70.4501L0.600006 69.8501V68.6701Z",
    fill: "url(#paint55_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 67.9202L0.44043 68.2202L0.740448 68.5202H1.93042L2.23044 68.2202L1.93042 67.9202H0.740448Z",
    fill: "url(#paint56_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 66.59L0 65.99V67.78L0.300018 68.08L0.600006 67.78V67.49V66.59Z",
    fill: "url(#paint57_linear_2371_121358)"
  }))), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.41
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 60.9701L2.52963 60.3601H0.139648L0.739655 60.9701H1.92963Z",
    fill: "url(#paint58_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 62.29L2.3703 62.59L2.67032 62.29V60.51L2.07031 61.11V62.29Z",
    fill: "url(#paint59_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 63.1801V64.3601L2.67032 64.9701V63.1801L2.3703 62.8801L2.07031 63.1801Z",
    fill: "url(#paint60_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 64.51L0.139648 65.11H2.52963L1.92963 64.51H0.739655Z",
    fill: "url(#paint61_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 62.4402L0.44043 62.7402L0.740448 63.0402H1.93042L2.23044 62.7402L1.93042 62.4402H0.740448Z",
    fill: "url(#paint62_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 60.51V62V62.29L0.300018 62.59L0.600006 62.29V62V61.11L0 60.51Z",
    fill: "url(#paint63_linear_2371_121358)"
  }))), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.54
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 88.4L2.52963 87.8H0.139648L0.739655 88.4H1.92963Z",
    fill: "url(#paint64_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 90.6101V91.8001L2.67032 92.4001V90.6101L2.3703 90.3101L2.07031 90.6101Z",
    fill: "url(#paint65_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 91.9399L0.139648 92.5399H2.52963L1.92963 91.9399H0.739655Z",
    fill: "url(#paint66_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 89.8701L0.44043 90.1701L0.740448 90.4701H1.93042L2.23044 90.1701L1.93042 89.8701H0.740448Z",
    fill: "url(#paint67_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 88.5399L0 87.9399V89.7299L0.300018 90.0299L0.600006 89.7299V89.4399V88.5399Z",
    fill: "url(#paint68_linear_2371_121358)"
  }))), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.69
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 82.9101L2.52963 82.3101H0.139648L0.739655 82.9101H1.92963Z",
    fill: "url(#paint69_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 85.1301V86.3101L2.67032 86.9201V85.1301L2.3703 84.8301L2.07031 85.1301Z",
    fill: "url(#paint70_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 86.46L0.139648 87.06H2.52963L1.92963 86.46H0.739655Z",
    fill: "url(#paint71_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 85.1301L0.300018 84.8301L0 85.1301V86.9201L0.600006 86.3101V85.1301Z",
    fill: "url(#paint72_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 84.3801L0.44043 84.6801L0.740448 84.9901H1.93042L2.23044 84.6801L1.93042 84.3801H0.740448Z",
    fill: "url(#paint73_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 83.0599L0 82.45V84.2399L0.300018 84.5399L0.600006 84.2399V83.95V83.0599Z",
    fill: "url(#paint74_linear_2371_121358)"
  }))), _g16 || (_g16 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.89
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 78.76L2.3703 79.06L2.67032 78.76V76.97L2.07031 77.57V78.76Z",
    fill: "url(#paint75_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 79.6401V80.8301L2.67032 81.4301V79.6401L2.3703 79.3401L2.07031 79.6401Z",
    fill: "url(#paint76_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 78.8999L0.44043 79.1999L0.740448 79.4999H1.93042L2.23044 79.1999L1.93042 78.8999H0.740448Z",
    fill: "url(#paint77_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 76.97V78.46V78.76L0.300018 79.06L0.600006 78.76V78.46V77.57L0 76.97Z",
    fill: "url(#paint78_linear_2371_121358)"
  }))), _g17 || (_g17 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.45
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 104.86L2.52963 104.26H0.139648L0.739655 104.86H1.92963Z",
    fill: "url(#paint79_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 107.08V108.26L2.67032 108.86V107.08L2.3703 106.78L2.07031 107.08Z",
    fill: "url(#paint80_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 108.4L0.139648 109.01H2.52963L1.92963 108.4H0.739655Z",
    fill: "url(#paint81_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 106.33L0.44043 106.63L0.740448 106.93H1.93042L2.23044 106.63L1.93042 106.33H0.740448Z",
    fill: "url(#paint82_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 105L0 104.4V106.19L0.300018 106.49L0.600006 106.19V105.9V105Z",
    fill: "url(#paint83_linear_2371_121358)"
  }))), _g18 || (_g18 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.12
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 100.7L2.3703 101L2.67032 100.7V98.9199L2.07031 99.5199V100.7Z",
    fill: "url(#paint84_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 101.59V102.78L2.67032 103.38V101.59L2.3703 101.29L2.07031 101.59Z",
    fill: "url(#paint85_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 100.85L0.44043 101.15L0.740448 101.45H1.93042L2.23044 101.15L1.93042 100.85H0.740448Z",
    fill: "url(#paint86_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 99.5199L0 98.9199V100.7L0.300018 101L0.600006 100.7V100.41V99.5199Z",
    fill: "url(#paint87_linear_2371_121358)"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 121.95L2.52963 121.35H0.139648L0.739655 121.95H1.92963Z",
    fill: "url(#paint88_linear_2371_121358)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 124.16V125.35L2.67032 125.95V124.16L2.3703 123.86L2.07031 124.16Z",
    fill: "url(#paint89_linear_2371_121358)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 125.49L0.139648 126.09H2.52963L1.92963 125.49H0.739655Z",
    fill: "url(#paint90_linear_2371_121358)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 123.42L0.44043 123.72L0.740448 124.02H1.93042L2.23044 123.72L1.93042 123.42H0.740448Z",
    fill: "url(#paint91_linear_2371_121358)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 122.09L0 121.49V123.28L0.300018 123.58L0.600006 123.28V122.98V122.09Z",
    fill: "url(#paint92_linear_2371_121358)"
  })), _g19 || (_g19 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.1
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 117.79L2.3703 118.09L2.67032 117.79V116L2.07031 116.6V117.79Z",
    fill: "url(#paint93_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 118.67V119.86L2.67032 120.46V118.67L2.3703 118.37L2.07031 118.67Z",
    fill: "url(#paint94_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 117.93L0.44043 118.23L0.740448 118.53H1.93042L2.23044 118.23L1.93042 117.93H0.740448Z",
    fill: "url(#paint95_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 116V117.49V117.79L0.300018 118.09L0.600006 117.79V117.49V116.6L0 116Z",
    fill: "url(#paint96_linear_2371_121358)"
  }))), _g20 || (_g20 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.98
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 143.9L2.52963 143.3H0.139648L0.739655 143.9H1.92963Z",
    fill: "url(#paint97_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 146.11V147.3L2.67032 147.9V146.11L2.3703 145.81L2.07031 146.11Z",
    fill: "url(#paint98_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 147.44L0.139648 148.04H2.52963L1.92963 147.44H0.739655Z",
    fill: "url(#paint99_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 145.37L0.44043 145.67L0.740448 145.97H1.93042L2.23044 145.67L1.93042 145.37H0.740448Z",
    fill: "url(#paint100_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 144.04L0 143.44V145.22L0.300018 145.53L0.600006 145.22V144.93V144.04Z",
    fill: "url(#paint101_linear_2371_121358)"
  }))), _g21 || (_g21 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.16
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.9306 138.41L2.53061 137.81H0.140625L0.740631 138.41H1.9306Z",
    fill: "url(#paint102_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 139.74L2.3703 140.04L2.67032 139.74V137.95L2.07031 138.55V139.74Z",
    fill: "url(#paint103_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 140.62V141.81L2.67032 142.41V140.62L2.3703 140.32L2.07031 140.62Z",
    fill: "url(#paint104_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740631 141.95L0.140625 142.55H2.53061L1.9306 141.95H0.740631Z",
    fill: "url(#paint105_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 139.88L0.44043 140.18L0.740448 140.48H1.93042L2.23044 140.18L1.93042 139.88H0.740448Z",
    fill: "url(#paint106_linear_2371_121358)"
  }))), _g22 || (_g22 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.71
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 132.92L2.52963 132.32H0.139648L0.739655 132.92H1.92963Z",
    fill: "url(#paint107_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 134.25L2.3703 134.55L2.67032 134.25V132.46L2.07031 133.06V134.25Z",
    fill: "url(#paint108_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 135.14V136.32L2.67032 136.92V135.14L2.3703 134.83L2.07031 135.14Z",
    fill: "url(#paint109_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 136.46L0.139648 137.07H2.52963L1.92963 136.46H0.739655Z",
    fill: "url(#paint110_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 134.39L0.44043 134.69L0.740448 134.99H1.93042L2.23044 134.69L1.93042 134.39H0.740448Z",
    fill: "url(#paint111_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 132.46V133.96V134.25L0.300018 134.55L0.600006 134.25V133.96V133.06L0 132.46Z",
    fill: "url(#paint112_linear_2371_121358)"
  }))), _g23 || (_g23 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.02
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 160.36L2.52963 159.76H0.139648L0.739655 160.36H1.92963Z",
    fill: "url(#paint113_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 162.57V163.76L2.67032 164.36V162.57L2.3703 162.27L2.07031 162.57Z",
    fill: "url(#paint114_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 163.9L0.139648 164.5H2.52963L1.92963 163.9H0.739655Z",
    fill: "url(#paint115_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 161.83L0.44043 162.13L0.740448 162.43H1.93042L2.23044 162.13L1.93042 161.83H0.740448Z",
    fill: "url(#paint116_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 160.5L0 159.9V161.69L0.300018 161.99L0.600006 161.69V161.39V160.5Z",
    fill: "url(#paint117_linear_2371_121358)"
  }))), _g24 || (_g24 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.77
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 154.87L2.52963 154.27H0.139648L0.739655 154.87H1.92963Z",
    fill: "url(#paint118_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 156.2L2.3703 156.5L2.67032 156.2V154.41L2.07031 155.01V156.2Z",
    fill: "url(#paint119_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 157.08V158.27L2.67032 158.87V157.08L2.3703 156.78L2.07031 157.08Z",
    fill: "url(#paint120_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 158.41L0.139648 159.01H2.52963L1.92963 158.41H0.739655Z",
    fill: "url(#paint121_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 157.08L0.300018 156.78L0 157.08V158.87L0.600006 158.27V157.08Z",
    fill: "url(#paint122_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.600006 155.01L0 154.41V156.2L0.300018 156.5L0.600006 156.2V155.9V155.01Z",
    fill: "url(#paint123_linear_2371_121358)"
  }))), _g25 || (_g25 = /*#__PURE__*/React.createElement("g", {
    opacity: 0.57
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.92963 149.38L2.52963 148.78H0.139648L0.739655 149.38H1.92963Z",
    fill: "url(#paint124_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 150.71L2.3703 151.01L2.67032 150.71V148.92L2.07031 149.53V150.71Z",
    fill: "url(#paint125_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.07031 151.6V152.78L2.67032 153.39V151.6L2.3703 151.3L2.07031 151.6Z",
    fill: "url(#paint126_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.739655 152.93L0.139648 153.53H2.52963L1.92963 152.93H0.739655Z",
    fill: "url(#paint127_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.740448 150.85L0.44043 151.15L0.740448 151.46H1.93042L2.23044 151.15L1.93042 150.85H0.740448Z",
    fill: "url(#paint128_linear_2371_121358)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 148.92V150.42V150.71L0.300018 151.01L0.600006 150.71V150.42V149.53L0 148.92Z",
    fill: "url(#paint129_linear_2371_121358)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2371_121358",
    x1: 1.34062,
    y1: 161.05,
    x2: 1.34062,
    y2: -3.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04998,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_2371_121358",
    x1: 1.34062,
    y1: 161.05,
    x2: 1.34062,
    y2: -3.0501,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04992,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_2371_121358",
    x1: 0.300001,
    y1: 161.04,
    x2: 0.300001,
    y2: -3.05004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint9_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.05001,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint10_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05004,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint12_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint13_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint14_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint15_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint16_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint17_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint18_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05014,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint19_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05002,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint20_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_2371_121358",
    x1: 0.300001,
    y1: 161.04,
    x2: 0.300001,
    y2: -3.05012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint22_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint23_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_2371_121358",
    x1: 1.33964,
    y1: 161.03,
    x2: 1.33964,
    y2: -3.04983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.04983,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint27_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.04994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05018,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05033,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.05015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint34_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint36_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.04993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04999,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint38_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04987,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_2371_121358",
    x1: 1.33964,
    y1: 161.051,
    x2: 1.33964,
    y2: -3.05006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint40_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04986,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint42_linear_2371_121358",
    x1: 1.34043,
    y1: 161.051,
    x2: 1.34043,
    y2: -3.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_2371_121358",
    x1: 0.300001,
    y1: 161.04,
    x2: 0.300001,
    y2: -3.04997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint44_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04997,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint46_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint48_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint50_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_2371_121358",
    x1: 1.33964,
    y1: 161.051,
    x2: 1.33964,
    y2: -3.0506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint52_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint54_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05009,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05003,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint56_linear_2371_121358",
    x1: 1.34043,
    y1: 161.051,
    x2: 1.34043,
    y2: -3.05056,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05015,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint58_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04995,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint60_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04982,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint62_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04965,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05005,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint64_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05012,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint66_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint67_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint68_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint69_linear_2371_121358",
    x1: 1.33964,
    y1: 161.041,
    x2: 1.33964,
    y2: -3.04081,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint70_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04981,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.04977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint73_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04996,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint74_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.0499,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint75_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint76_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04977,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint77_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04988,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint78_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.04989,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint79_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.04972,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint80_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05007,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint81_linear_2371_121358",
    x1: 1.33964,
    y1: 161.05,
    x2: 1.33964,
    y2: -3.05021,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint82_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.04964,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint83_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.04991,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint84_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.05017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint85_linear_2371_121358",
    x1: 2.37032,
    y1: 161.05,
    x2: 2.37032,
    y2: -3.04978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint86_linear_2371_121358",
    x1: 1.34043,
    y1: 161.05,
    x2: 1.34043,
    y2: -3.0512,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint87_linear_2371_121358",
    x1: 0.300005,
    y1: 161.05,
    x2: 0.300005,
    y2: -3.05017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint88_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05865,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint89_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05963,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint90_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint91_linear_2371_121358",
    x1: 1.34043,
    y1: 167.16,
    x2: 1.34043,
    y2: 3.0587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint92_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.05952,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint93_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint94_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.06031,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint95_linear_2371_121358",
    x1: 1.34043,
    y1: 167.16,
    x2: 1.34043,
    y2: 3.06023,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint96_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.05978,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint97_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05838,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint98_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.06006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint99_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05823,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint100_linear_2371_121358",
    x1: 1.34043,
    y1: 167.16,
    x2: 1.34043,
    y2: 3.05843,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint101_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.05891,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint102_linear_2371_121358",
    x1: 1.34062,
    y1: 167.159,
    x2: 1.34062,
    y2: 3.06188,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint103_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint104_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.06006,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint105_linear_2371_121358",
    x1: 1.34062,
    y1: 167.159,
    x2: 1.34062,
    y2: 3.06183,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint106_linear_2371_121358",
    x1: 1.34043,
    y1: 167.16,
    x2: 1.34043,
    y2: 3.05849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint107_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05851,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint108_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint109_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.0591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint110_linear_2371_121358",
    x1: 1.33964,
    y1: 167.15,
    x2: 1.33964,
    y2: 3.07958,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint111_linear_2371_121358",
    x1: 1.34043,
    y1: 167.159,
    x2: 1.34043,
    y2: 3.0619,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint112_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.05994,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint113_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05842,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint114_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05913,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint115_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05827,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint116_linear_2371_121358",
    x1: 1.34043,
    y1: 167.16,
    x2: 1.34043,
    y2: 3.05847,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint117_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.06017,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint118_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05849,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint119_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint120_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.06029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint121_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05834,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint122_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.06029,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint123_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.05907,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint124_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.06201,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint125_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint126_linear_2371_121358",
    x1: 2.37032,
    y1: 167.16,
    x2: 2.37032,
    y2: 3.05898,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint127_linear_2371_121358",
    x1: 1.33964,
    y1: 167.16,
    x2: 1.33964,
    y2: 3.05817,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint128_linear_2371_121358",
    x1: 1.34043,
    y1: 167.16,
    x2: 1.34043,
    y2: 3.0597,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint129_linear_2371_121358",
    x1: 0.300005,
    y1: 167.16,
    x2: 0.300005,
    y2: 3.05993,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#31CF05"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#239A03"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMatrix2);
export default __webpack_public_path__ + "static/media/matrix-2.72e2aa3a0f4416fddf423394bd4f49dd.svg";
export { ForwardRef as ReactComponent };